import ChevronRight from "~icons/material-symbols/chevron-right";

import { css } from "../../../../styled-system/css";

export function StoresSkeleton() {
  return (
    <div className={css({ px: "16px", maxWidth: "100%" })}>
      <div className={css({ bg: "white", rounded: "xl", maxWidth: "100%" })}>
        {[1, 2, 3, 4, 5].map((d, index) => (
          <div
            key={`skeleton-${d}`}
            className={css({
              display: "flex",
              alignItems: "center",
              pl: "16px",
              maxWidth: "100%",
              gap: "16px",
              width: "full",
            })}
          >
            <div
              className={css({
                width: "32px",
                height: "32px",
                borderRadius: "full",
                background:
                  "linear-gradient(110deg, #e8e8e8 8%, #f5f5f5 18%, #e8e8e8 33%)",
                backgroundSize: "200% 600%",
                animation: "1.2s shine linear infinite",
                flexShrink: 0,
              })}
            />
            <div
              className={css({
                flexGrow: 1,
                display: "flex",
                borderBottom: index === 4 ? "none" : "1px solid",
                py: "16px",
                maxWidth: "calc(100% - 48px)",
                borderColor: "border.secondary",
              })}
            >
              <div className={css({ flex: 1, minWidth: 0 })}>
                <div
                  className={css({
                    width: "120px",
                    height: "16px",
                    background:
                      "linear-gradient(110deg, #e8e8e8 8%, #f5f5f5 18%, #e8e8e8 33%)",
                    backgroundSize: "200% 600%",
                    animation: "1.2s shine linear infinite",
                    rounded: "md",
                    mb: "8px",
                  })}
                />
                <div
                  className={css({
                    width: "80px",
                    height: "12px",
                    background:
                      "linear-gradient(110deg, #e8e8e8 8%, #f5f5f5 18%, #e8e8e8 33%)",
                    backgroundSize: "200% 600%",
                    animation: "1.2s shine linear infinite",
                    rounded: "md",
                  })}
                />
              </div>
              <div
                className={css({
                  color: "text.tertiary",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pr: "8px",
                  flexShrink: 0,
                })}
              >
                <ChevronRight strokeWidth={1} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
